<template>
    <v-container class="fill-height data-container" fluid>
        <v-form ref="form" :lazy-validation="true" v-model="formValid">

            <v-stepper class="stepper" v-model="currentStep">
                <v-stepper-header style="height: 50px;">
                    <v-stepper-step class="stepper-step" step="1" :complete="currentStep > 1" editable :color="'#c42111'">Group Details</v-stepper-step>
                    <v-divider style="margin: 0px -6px;"></v-divider>
                    <v-stepper-step class="stepper-step" step="2" :complete="currentStep > 2" editable :color="'#c42111'">Group Permissions</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items class="stepper-content-container">
                    <v-stepper-content :step="1" class="stepper-content">
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Group Name" color="#c42111" v-model="$props.userGroup.group_name" :disabled="!isCustomerAdmin" :rules="[validation.required($props.userGroup.group_name, 'Group Name'), validation.unique($props.userGroup, $props.userGroupsList)]" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete autocomplete="off" label="Group's Manager" v-model="$props.userGroup.group_manager" :disabled="!isCustomerAdmin" color="#c42111" :items="managerList" item-value="user_id" :filter="search">
                                    <template v-slot:selection="data">
                                            <template v-if="data.item.user_id">
                                                <v-img class="mr-2" width="24" height="24" max-width="24" max-height="24" style="border-radius: 50%" :src="data.item.userImage" v-if="data.item.userImage" />
                                                <v-icon class="mr-2" v-else>mdi-account-circle</v-icon>
                                            </template>
                                        {{ data.item.user_fullname }}
                                    </template>

                                    <template v-slot:item="data">
                                        <v-list-item-avatar v-if="data.item.user_id">
                                            <v-img :src="data.item.userImage" v-if="data.item.userImage" />
                                            <v-icon x-large v-else>mdi-account-circle</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.user_fullname }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ data.item.user_username }} <span class="admin-text" v-if="data.item.user_data.is_customer_admin">(administrator)</span></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <v-autocomplete autocomplete="off" label="Group Members" v-model="$props.userGroup.group_members" multiple color="#c42111" :items="$store.state.batchConfig.users" item-value="user_id" :filter="search">
                                    <template v-slot:selection="data">
                                        <v-chip :class="{admin: data.item.user_data.is_customer_admin}" v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="remove(data.item)">
                                            <v-avatar left>
                                                <v-img :src="data.item.userImage" v-if="data.item.userImage" />
                                                <v-icon v-else>mdi-account-circle</v-icon>
                                            </v-avatar>
                                            {{ data.item.user_fullname }}
                                        </v-chip>
                                    </template>

                                    <template v-slot:item="data">
                                        <v-list-item-avatar>
                                            <v-img :src="data.item.userImage" v-if="data.item.userImage" />
                                            <v-icon x-large v-else>mdi-account-circle</v-icon>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.user_fullname }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ data.item.user_username }} <span class="admin-text" v-if="data.item.user_data.is_customer_admin">(administrator)</span></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-stepper-content>

                    <v-stepper-content :step="2" class="stepper-content">
                        <permissions :type="'group'" :id="$props.userGroup.group_id" :permissionsList="$props.userGroupsResources.permissionsList" :activePermissions="userGroup.permissions" :lockSave="lockSave"></permissions>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>

            <v-row class="mt-3">
                <v-btn class="ml-3 mr-3" color="#c42111" @click="saveClick" :disabled="$props.lockSave">Save</v-btn>
                <v-btn class="mr-3" color="#c42111" @click="cancelClicked">Cancel</v-btn>
            </v-row>

        </v-form>
    </v-container>
</template>

<script>
import Permissions from "@/components/Users/Permissions";
export default {
    name: 'UserGroupEdit',
    props: ['userGroup', 'userGroupsList', 'userGroupsResources', 'lockSave'],
    components: {
        Permissions
    },
    data: () => ({
        formValid: true,
        currentStep: 1,
        managerList: [],
        membersList: [],
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            unique: (value, groups) => (!value.group_name || value.group_id != 0 || !groups.some(ug => {return (ug.group_name == value.group_name.trim())})) || 'This User Group Name is already is use. '
        }
    }),

    computed: {
        isCustomerAdmin: function() {
            return (this.$store.state.user.user_data.is_customer_admin);
        }
    },

    methods: {
        createResourceLists: function() {
            this.managerList = structuredClone(this.$store.state.batchConfig.users);
            this.managerList.unshift({user_fullname: '[none]', user_id: 0, user_data: {}});
        },

        saveClick: function() {
            if(this.$refs.form.validate()) {
            this.$emit('save', this.$props.userGroup);
            }
        },

        cancelClicked: function() {
            if(this.$store.state.isDirty) {
                this.$store.commit('showConfirmModal', {
                    title: 'Are you sure?',
                    message: 'Are you sure you want to abandon your changes without saving?',
                    type: 'warning',
                    confirmAction: () => {this.$store.commit('setIsDirty', false); this.$emit('cancel');}
                });
            }
            else {
                this.$emit('cancel');
            }
        },

        clearManager() {
            this.$props.userGroup.group_manager = null;
        },

        remove(item) {
            const index = this.$props.userGroup.group_members.indexOf(item.user_id);
            if(index >= 0) {
                this.$props.userGroup.group_members.splice(index, 1);
            }
        },

        search(item, queryText, itemText) {
            return (item.user_fullname.toLowerCase().includes(queryText.toLowerCase()) ||
                (item.user_username && item.user_username.toLowerCase().includes(queryText.toLowerCase()))
            );
        }
    },

    watch: {
        userGroup: {
            handler(newVal, oldVal) {
                if(!this.$props.lockSave) {
                    this.$store.commit('setIsDirty', true);
                }
            },
            deep: true
        }
    },

    mounted() {
        this.createResourceLists();
    }

  
};
</script>

<style scoped>

    .stepper {
        background: #424242; 
        height: calc(100vh - 126px);
    }
    .stepper .stepper-step {
        padding: 12px 24px;
    }
    .stepper-content-container {
        overflow-y: auto; 
    }
    .stepper-content {
        /* padding: 16px 4px 4px 4px; */
    }

    .data-container {
        padding: 0;
    }

    .admin {
        /* background-color: rgba(255, 255, 0, 0.4) !important; */
        background-color: rgba(255, 255, 0, 1) !important;
        color: gray;
    }
    .admin-text {
        color: yellow;
    }

</style>
